'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = uploadListItemFiles;

var _uploadListItemFile = require('./uploadListItemFile');

var _uploadListItemFile2 = _interopRequireDefault(_uploadListItemFile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Upload list of files as attachment to a list item.
 *
 * @param {string} list Name of list.
 * @param {string} id Id of item.
 * @param {Object[]} files {file: string, name: string}[]
 * @return {Promise}
 */
function uploadListItemFiles(list, id, files) {
    return Promise.each(files.map(function (file) {
        return (0, _uploadListItemFile2.default)(list, id, file);
    }));
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ntnu-react/util/sp/uploadListItemFiles.js
// module id = 1045
// module chunks = 0